import React, {useState, useRef, useEffect} from 'react';
import ActionItemCommentListItem from './ActionItemCommentListItem.mjs';
import { useCTAL } from './CTAL_Hooks.js';

const DEBUG = 0;

export default function ActionItemCommentList({}) 
{
    const { action_item_comments } = useCTAL();

    if (DEBUG) return;

    return ( 
        <div class="sticky">
            <ol class="list-group mt-2">
                { action_item_comments?.map( (comment, i) => ( <ActionItemCommentListItem comment={comment} key={i} /> )) } 
            </ol>
        </div>
    );
}